<template>
    <div class="login_con">
        <nav-bar :navigationIndex="null" bgColor="#047E41" />
        <div style="height:125px"></div>
        <div class="flex_around">
            <div class="login_main">
                <div class="login_box">
                    <div class="login_title flex">
                        <div class="flex_center flex_column"
                            :class="formState.userType == '01' ? 'title_left' : 'title_right'"
                            @click="handleChangeType('01')">
                            <span>个人注册</span>
                            <div class="login_line" v-if="formState.userType == '01'"></div>
                        </div>
                        <div class="title_center">
                            /
                        </div>
                        <div :class="formState.userType == '02' ? 'title_left' : 'title_right'"
                            @click="handleChangeType('02')"><span> 企业注册</span>
                            <div class="login_line" v-if="formState.userType == '02'"></div>
                        </div>

                    </div>
                    <div class="login_input flex">
                        <el-icon color="#00AC64" style="font-size: 19px">
                            <Avatar />
                        </el-icon>
                        <input placeholder="请输入手机号" v-model.trim="formState.username" type="text" />
                    </div>
                    <div class="login_input flex">
                        <el-icon color="#00AC64" style="font-size: 19px">
                            <Lock />
                        </el-icon>
                        <input placeholder="请输入密码" v-model.trim="formState.password"
                            :type="isPasswordVisible ? 'text' : 'password'" />
                        <el-icon class="cursor" style="font-size: 22px;" @click="viewPass(false)"
                            v-if="isPasswordVisible">
                            <Hide />
                        </el-icon>
                        <el-icon class="cursor" style="font-size: 22px;" @click="viewPass(true)" v-else>
                            <View />
                        </el-icon>
                    </div>
                    <div class="login_input flex" style="align-items: center;">
                        <el-icon color="#00AC64" style="font-size: 19px">
                            <Finished />
                        </el-icon>
                        <input placeholder="请输入验证码" v-model.trim="formState.code" type="text" />
                        <button class="get-code" @click="handleCode">{{ countdownText }}</button>
                    </div>
                    <!-- <el-form :model="formState" :rules="rules" ref="formState" label-width="110px"
                        class="demo-formState" label-position="top">
                        <template v-if="pageNum == 1">
                            <el-form-item label="账号(手机号)" prop="username">
                                <el-input v-model="formState.username" placeholder="请输入账号(手机号)"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" prop="password">
                                <el-input v-model="formState.password" placeholder="请输入请输入密码"
                                    type="password"></el-input>
                            </el-form-item>
                            <el-form-item label="验证码" prop="username">
                                <el-input v-model="formState.username" placeholder="请输入验证码">
                                    <template #suffix><el-button @click="handleCode" link style="color: #00AC64;">获取验证码</el-button></template>
</el-input>
</el-form-item>
<el-form-item label="用户类型" prop="userType">
    <el-radio-group v-model="formState.userType">
        <el-radio value="01" size="large">个人</el-radio>
        <el-radio value="02" size="large">企业</el-radio>
    </el-radio-group>
</el-form-item>
</template>
<template v-else>
                            <el-form-item label="身份证号" prop="xhUserInfo.userCode" v-if="formState.userType == '01'">
                                <el-input v-model="formState.xhUserInfo.userCode" placeholder="请输入身份证号"></el-input>
                            </el-form-item>
                            <el-form-item :label="formState.userType == '01' ? '姓名' : '企业名称'"
                                prop="xhUserInfo.userName">
                                <el-input v-model="formState.xhUserInfo.userName" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="企业统一信用代码" prop="xhUserInfo.companyCode"
                                v-if="formState.userType == '02'">
                                <el-input v-model="formState.xhUserInfo.companyCode"
                                    placeholder="请输入企业统一信用代码"></el-input>
                            </el-form-item>
                            <el-form-item label="法人姓名" prop="xhUserInfo.companyLegal" v-if="formState.userType == '02'">
                                <el-input v-model="formState.xhUserInfo.companyLegal" placeholder="请输入法人姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="法人身份证" prop="xhUserInfo.companyLegalCode"
                                v-if="formState.userType == '02'">
                                <el-input v-model="formState.xhUserInfo.companyLegalCode"
                                    placeholder="法人身份证"></el-input>
                            </el-form-item>
                            <el-form-item label="企业联系人" prop="xhUserInfo.companyContact"
                                v-if="formState.userType == '02'">
                                <el-input v-model="formState.xhUserInfo.companyContact"
                                    placeholder="请输入企业联系人"></el-input>
                            </el-form-item>
                            <el-form-item label="企业联系方式" prop="xhUserInfo.companyContactPhone"
                                v-if="formState.userType == '02'">
                                <el-input v-model="formState.xhUserInfo.companyContactPhone"
                                    placeholder="请输入企业联系方式"></el-input>
                            </el-form-item>
                            <el-form-item label="企业地址" prop="xhUserInfo.companyAddress"
                                v-if="formState.userType == '02'">
                                <el-input v-model="formState.xhUserInfo.companyAddress"
                                    placeholder="请输入企业地址"></el-input>
                            </el-form-item>
                            <el-form-item label="银行账户名称" prop="xhUserInfo.bankAccountName">
                                <el-input v-model="formState.xhUserInfo.bankAccountName"
                                    placeholder="请输入银行账户名称"></el-input>
                            </el-form-item>
                            <el-form-item label="银行账号" prop="xhUserInfo.bankNo">
                                <el-input v-model="formState.xhUserInfo.bankNo" placeholder="请输入银行账号"></el-input>
                            </el-form-item>
                            <el-form-item label="银行预留手机号" prop="xhUserInfo.bankPhone">
                                <el-input v-model="formState.xhUserInfo.bankPhone" placeholder="银行预留手机号"></el-input>
                            </el-form-item>
                        </template>
<el-form-item>
    <el-button type="primary" @click="submitForm('formState')">立即保存</el-button>
</el-form-item>
</el-form> -->
                    <!-- <div class="login_input flex">
                        <el-icon>
                            <Lock />
                        </el-icon>
                        <input placeholder="确认密码" type="text" />
                    </div>
                    <div class="code_box flex_between">
                        <input class="code_input" placeholder="请输入手机验证码" type="text" />
                        <img src="" alt="" />
                    </div>
                    <div class="code_box flex_between">
                        <input class="code_input" placeholder="请输入验证码" type="text" />
                        <img src="" alt="" />
                    </div> -->
                    <!-- <template v-if="pageNum == 1">
                        <div class="login_btn" @click="nextPage()">
                            <button>下一步</button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="btn-wrap">
                            <button @click="lastPage()" class="last-page">上一步</button>
                          
                        </div>
                    </template> -->
                    <div class="login_btn">
                        <button @click="getRegister()">注册</button>
                    </div>
                    <div class="cursor" @click="goPage('/loginPage')">
                        <div>已有帐户？去登录</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { register, sendMsg } from "@/utils/api";
// @ is an alias to /src

export default {
    components: {
    },
    data() {
        return {
            formState: {
                username: '',
                password: '',
                userType: '01',
                code: ""
                // xhUserInfo: {
                //     userCode: "",
                //     userName: "",
                //     companyCode: "",
                //     companyLegal: "",
                //     companyLegalCode: "",
                //     companyContact: "",
                //     companyContactPhone: "",
                //     companyAddress: "",
                //     bankAccountName: "",
                //     bankNo: "",
                //     bankPhone: "",
                // },

            },

            rules: {
                username: [
                    { required: true, message: "请输入手机号", trigger: "blur" },
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    { min: 6, max: 12, message: "长度在 6 到 12 个字符", trigger: "blur" }
                ],
                userType: [
                    { required: true, message: "请选择用户类型", trigger: "change" },
                ],
                // 'xhUserInfo.userCode': [
                //     { required: true, message: "请输入身份证号", trigger: "blur" },
                // ],
                // 'xhUserInfo.userName': [
                //     { required: true, message: "请输入名称", trigger: "blur" },
                // ],
                // 'xhUserInfo.companyCode': [
                //     { required: true, message: "请输入企业统一信用代码", trigger: "blur" },
                // ],
                // 'xhUserInfo.companyLegal': [
                //     { required: true, message: "请输入法人姓名", trigger: "blur" },
                // ],
                // 'xhUserInfo.companyLegalCode': [
                //     { required: true, message: "请输入法人身份证", trigger: "blur" },
                // ],
                // 'xhUserInfo.companyContact': [
                //     { required: true, message: "请输入企业联系人", trigger: "blur" },
                // ],
                // 'xhUserInfo.companyContactPhone': [
                //     { required: true, message: "请输入企业联系方式", trigger: "blur" },
                // ],
                // 'xhUserInfo.companyAddress': [
                //     { required: true, message: "请输入企业地址", trigger: "blur" },
                // ],
                // 'xhUserInfo.bankAccountName': [
                //     { required: true, message: "请输入银行账户名称", trigger: "blur" },
                // ],
                // 'xhUserInfo.bankNo': [
                //     { required: true, message: "请输入银行账号", trigger: "blur" },
                // ],
                // 'xhUserInfo.bankPhone': [
                //     { required: true, message: "请输入银行预留手机号", trigger: "blur" },
                // ],
            },
            pageNum: 1,
            countdown: 60,
            countdownText: "获取验证码",
            isCountdown: false,
            isSend: false,
            isPasswordVisible: false,
        }
    },
    mounted() {
    },
    methods: {
        // 查看密码
        viewPass(isPassword) {
            // console.log(isPassword);
            this.isPasswordVisible = isPassword;
        },
        handleCode() {
            if (this.formState.username == '' || this.formState.username == null) {
                this.$message.error('手机号不能为空');
                return;
            }
            if (this.isCountdown) {
                return;
            }
            sendMsg({ phone: this.formState.username }).then((res) => {
                if (res.code == 200) {
                    this.isSend = true;
                    this.countdown = 60;
                    this.countdownText = "获取验证码";
                    this.isCountdown = true;
                    let timer = setInterval(() => {
                        if (this.countdown > 0) {
                            this.countdown--;
                            this.countdownText = this.countdown + "s";
                        } else {
                            this.isCountdown = false;
                            this.countdownText = "获取验证码";
                            clearInterval(timer);
                        }
                    }, 1000);
                }
            })
        },
        handleChangeType(type) {
            if (this.pageNum == 2) {
                return;
            }
            this.formState.userType = type
        },
        // 下一页
        nextPage() {
            if (!this.formState.username || !this.formState.password || !this.formState.userType) {
                this.$message.error("请填写必填项");
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.formState.username)) {
                this.$message.error("手机号码有误，请重填");
                return;
            }
            this.pageNum = 2
        },
        lastPage() {
            this.pageNum = 1
        },
        getRegister() {
            // if (this.formState.userType == '02') {
            //     if (!/^1[3456789]\d{9}$/.test(this.formState.xhUserInfo.companyContactPhone)) {
            //         this.$message.error("企业联系方式有误，请重填");
            //         return;
            //     }

            //     if (!/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(this.formState.xhUserInfo.companyLegalCode)) {
            //         this.$message.error("法人身份证有误，请重填");
            //         return;
            //     }
            // } else {
            //     if (!/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(this.formState.xhUserInfo.userCode)) {
            //         this.$message.error("身份证有误，请重填");
            //         return;
            //     }
            // }

            // if (!/^1[3456789]\d{9}$/.test(this.formState.xhUserInfo.bankPhone)) {
            //     this.$message.error("银行预留手机号有误，请重填");
            //     return;
            // }

            // this.$refs.formState.validate((valid) => {
            //     if (valid) {
            //         register(this.formState).then((res) => {
            //             console.log(res);
            //             if (res.code == 200) {
            //                 this.$message.success("注册成功");
            //                 this.goPage("/loginPage");
            //             } else {
            //                 this.$message.error(res.msg);
            //             }
            //         });
            //     } else {
            //         return false;
            //     }
            // });
            if (this.formState.username == '' || this.formState.username == null) {
                this.$message.error('手机号不能为空');
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.formState.username)) {
                this.$message.error("手机号码有误，请重填");
                return;
            }
            if (this.formState.password == '' || this.formState.password == null) {
                this.$message.error('请输入密码');
                return;
            }
            if (this.formState.code == '' || this.formState.code == null) {
                this.$message.error('请输入验证码');
                return;
            }
            register(this.formState).then((res) => {
                if (res.code == 200) {
                    this.$message.success("注册成功");
                    this.goPage("/loginPage");
                } else {
                    this.$message.error(res.msg);
                }
            });

        },
        goPage(path) {
            this.$router.push({
                path: path
            });
        }
    }
}
</script>

<style scoped lang="scss">
.login_con {
    height: 100vh;
    background: url("@/assets/images/regBg.png") no-repeat center;
    background-size: 100% 100%;
}

.login_main {
    position: fixed;
    top: 53%;
    left: 75%;
    transform: translate(-50%, -50%);
    width: 420px;
    background-color: #fff;
    // box-shadow: 0 0 16px 2px rgba(19, 128, 56, .6);
    border-radius: 11px;
}

.login_box {
    padding: 70px 30px 30px 30px;
    // max-height: 530px;
    // overflow: auto;

    // &::-webkit-scrollbar {
    //     display: none; // 滚动条隐藏
    // }
}

.login_title {
    font-size: 40px;
    color: #00AC64;
    margin-bottom: 20px;
    line-height: 50px;
    font-family: SOURCEHANSANSCN-BOLD;
    display: flex;
    align-items: baseline;
}

.login_line {
    width: 90px;
    height: 2px;
    background: #00AC64;
    border-radius: 2px;
    margin-top: 3px;
}

.title_right {
    font-size: 21px;
    font-weight: 400;
    color: #626262;
    margin-left: 5px;
    margin-bottom: 10px;

}

.title_left {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.title_center {
    font-size: 21px;
    font-weight: 400;
    color: #626262;
    margin-left: 5px;
    margin-bottom: 10px;
}

// .code_box {
//     margin-top: 15px;
// }

// .code_input {
//     width: 50%;
//     background-color: #fff;
//     border-radius: 4px;
//     border: 1px solid #dcdfe6;
//     color: #606266;
//     height: 35px;
//     padding: 0 10px;
// }

// .code_box img {
//     width: 40%;
//     height: 35px;
//     background-color: #11672e;
// }

.login_btn button {
    width: 100%;
    height: 40px;
    color: #fff;
    background-color: #00AC64;
    border: none;
    border-radius: 4px;
    margin-top: 60px;
    margin-bottom: 15px;
    font-size: 20px;
    font-family: SOURCEHANSANSCN-REGULAR;
}

.btn-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    width: 100%;
    margin-bottom: 15px;

    .last-page {
        width: 38%;
        height: 40px;
        color: #00AC64;
        background-color: #fff;
        border: 1px solid #00AC64;
        border-radius: 4px;
        margin-top: 15px;
        font-size: 20px;
        font-family: SOURCEHANSANSCN-REGULAR;
    }

    .login_btn-reg {
        width: 60%;
        height: 40px;
        color: #fff;
        background-color: #00AC64;
        border: none;
        border-radius: 4px;
        margin-top: 15px;
        font-size: 20px;
        font-family: SOURCEHANSANSCN-REGULAR;
    }
}

.cursor {
    font-size: 14px;
    color: #00AC64;
}

// :deep .el-radio__input.is-checked .el-radio__inner {
//     color: #00AC64;
//     background-color: #00AC64;
//     border-color: #00AC64;
// }

// :deep .el-radio__label {
//     color: #00AC64;
// }

// :deep .el-radio__input.is-checked+.el-radio__label {
//     color: #00AC64;
// }

// :deep .el-form-item__label {
//     font-size: 16px;
// }

.login_input {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 35px;
    padding: 0 10px;
    margin-top: 20px;
    font-size: 40px;
}

.login_input input {
    border: none;
    color: #606266;
    height: 100%;
    font-size: 15px;
    margin: 0;
    padding: 0;
    padding-left: 10px;
    width: 250px;
    margin-right: 20px;
}

:deep .login_input {
    height: 50px;
    border: 2px solid #999999;
    border-radius: 7px;
}

.get-code {
    width: 40%;
    height: 30px;
    border-radius: 4px;
    // border: 1px solid #00AC64;
    background-color: #00AC64;
    text-align: center;
    line-height: 30px;
    color: #fff;
    border: none;
}
</style>